import styled from "styled-components";
import { alpha } from "../../typography";
import { Icon } from "../Icon";
import { LabelText } from "../common";
import { Tooltip } from "../Tooltip";
import { ReactNode } from "react";

const StyledLabelText = styled(LabelText)`
  ${alpha.primaryInactive.body3}
  margin-bottom: 12px;
`;

export type Props = {
  label: string;
  children: ReactNode;
  caption?: string;
  extraElement?: ReactNode;
};

export const TextWithLabel = ({
  label,
  children,
  caption,
  extraElement,
}: Props) => {
  return (
    <label>
      <StyledLabelText isReadOnly={true} hasError={false}>
        {label}
        {caption && (
          <Tooltip content={caption} defaultPlacement="right">
            <Icon iconSize="small" variant="ACTIVE" iconName="information" />
          </Tooltip>
        )}
        {extraElement}
      </StyledLabelText>
      {children}
    </label>
  );
};
